export async function copyTextToClipboard(text: string): Promise<boolean> {
  try {
    if (!navigator.clipboard) throw new Error('Clipboard API is not available');
    await navigator.clipboard.writeText(text);
    return true;
  } catch (error) {
    console.warn('[clipboard] Clipboard API copy failed, trying the text area method:', error);
  }
  return copyWithHiddenTextArea(text);
}

function copyWithHiddenTextArea(text: string): boolean {
  const textArea = document.createElement('textarea');
  textArea.value = text;
  textArea.style.position = 'fixed';
  textArea.style.opacity = '0';
  document.body.appendChild(textArea);
  try {
    textArea.select();
    return document.execCommand('copy');
  } catch (error) {
    console.warn('[clipboard] Text area copy failed:', error);
    return false;
  } finally {
    document.body.removeChild(textArea);
  }
}
